/** @format */

import React, { FC, useState } from 'react'
import { _$, Tab, Tabs } from '@king-design/react'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router'
import { PrometheusAlarmTabProps } from 'src/pages/PrometheusMonitor/Alarm'
import SilenceTab from './Silence'
import InhibitionTab from './Inhibition'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const PrometheusAlarmDenoise: FC<PrometheusAlarmTabProps> = ({ className, region, instances }) => {
  const history = useHistory()
  const query = useQuery()
  const initialDenoiseTab = query.get('denoiseTab') || 'inhibition'
  const [denoiseTab, setDenoiseTab] = useState<string>(initialDenoiseTab)

  return (
    <div className={className}>
      <Tabs
        value={denoiseTab}
        onChangeValue={tab => {
          history.push(`/monitor/prometheusmonitor/alarm?tab=denoise&denoiseTab=${tab}`)
          setDenoiseTab(tab)
        }}
      >
        <Tab value="inhibition">{_$('告警抑制')}</Tab>
        <Tab value="silence">{_$('告警静默')}</Tab>
      </Tabs>
      <div className="tab_content">
        {denoiseTab === 'inhibition' ? (
          <InhibitionTab tab={denoiseTab} region={region} instances={instances} />
        ) : null}
        {denoiseTab === 'silence' ? (
          <SilenceTab tab={denoiseTab} region={region} instances={instances} />
        ) : null}
      </div>
    </div>
  )
}

export default styled(PrometheusAlarmDenoise)``
